<template>
  <div class="app-shell">
    <main class="app-scroll">
      <router-view />
    </main>

    <div id="app-toast-container" class="toast-container position-fixed p-3" />
  </div>
</template>
